import Link from 'next/link';
import React from 'react';
import { SkipLinkWrapper, StyledSkipLink } from './SkipLinks.style';

const handleClick = (e, id) => {
    if (id.hash) {
        const focusArea = document.querySelector(id.hash);
        if (focusArea) {
            focusArea.focus();
            e.preventDefault();
        }
    }
};

const SkipLinks = () => (
    <SkipLinkWrapper>
        <SkipLink path={{ pathname: '/syntolkat' }} setFocus={false}>
            Gå direkt till samlingssidan Syntolkat
        </SkipLink>
        <SkipLink path={{ pathname: '/', hash: '#play_main-content' }}>Gå direkt till innehållet</SkipLink>
        <SkipLink path={{ pathname: '/', hash: '#search' }}>Gå direkt till sök </SkipLink>
    </SkipLinkWrapper>
);

const SkipLink = ({ path, children }) => (
    <Link href={path} passHref>
        <StyledSkipLink
            onClick={(e) => {
                handleClick(e, path);
            }}
        >
            {children}
        </StyledSkipLink>
    </Link>
);

export default SkipLinks;
